export class TxSetupModel {
    treatmentID: number
    start_date: string
    no_times: string
    repeat_in: string
    total_times: string
    immediately: boolean
    next: boolean

    constructor(
        treatmentID: number,
        start_date: string = null,
        no_times: string,
        repeat_in: string,
        total_times: string,
        immediately: boolean,
        next: boolean
    ) {
        this.treatmentID = treatmentID
        this.start_date = start_date
        this.no_times = no_times
        this.repeat_in = repeat_in
        this.total_times = total_times
        this.immediately = immediately
        this.next = next
    }
}